import {Serializables} from "../../../../typescript-plugin/entities/Serializables";
import {RemovedSlot} from "./RemovedSlot";

export class RemovedSlots extends Serializables<RemovedSlot> {
    protected CreateEntity(): RemovedSlot {
        return new RemovedSlot();
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/server/src/base/entities/leasing/unaivailability/RemovedSlots.ts